import React from 'react';
import { useTranslation } from 'next-i18next';
import PropTypes from 'prop-types';

import CheckboxFilter from '@spa/shared/components/Filters/Checkbox';
import Group from '@spa/shared/components/Filters/Group';
import { GroupItemsContainer } from './styles';
import { PROPERTY_FEATURES } from '@spa/shared/constants/propertyFeatures';

const filtersCategory = 'property-features';

const House = ({ fields, onChangeEventHandler }) => {
  const { t } = useTranslation('translations');
  const filters = Object.values(PROPERTY_FEATURES);

  return (
    <Group title={t('filters.sections.house-features')}>
      <GroupItemsContainer>
        {filters.map(filter => (
          <CheckboxFilter
            key={filter}
            name={filtersCategory}
            value={filter}
            onChange={onChangeEventHandler}
            selected={fields[filtersCategory] && fields[filtersCategory].includes(filter)}
            label={t(`filters.labels.${filtersCategory}.${filter}`)}
          />
        ))}
      </GroupItemsContainer>
    </Group>
  );
};

House.propTypes = {
  fields: PropTypes.object.isRequired,
  onChangeEventHandler: PropTypes.func.isRequired
};

export default House;
